import React from 'react';
import _ from 'lodash';

import * as Misc from './../../misc';

export default (props) => {
  const {item} = props;
  const isSelected = item.isSelected;
  const text = item.DisplayText;
  const disabledClass = isSelected ? '' : 'filter-button-listitem-renderers-disabled';
  const disabledRadioClassPostfix = isSelected ? '' : '-disabled';
  let subItemsElementRoot = null;
  if (item.Items && item.Items.length > 0) {
    const subItemsElements = item.Items.map(si => {
      return (
        <div className="filter-sub-menu-lir" key={si.Id}
             onClick={e => Misc.ignore(e, () => props.click(si.Value, 'subItem', item))}>
          <div
            className={`filter-sub-menu-radio ${(si.isSelected ? 'filter-sub-menu-radio-selected' : '')}`}>
            {si.isSelected ? <div className="filter-sub-menu-radio-filled"/> : null}
          </div>
          <span>{si.DisplayText}</span>
        </div>
      );
    });
    subItemsElementRoot = (
      <div className="filter-sub-menu-wrapper">
        {subItemsElements}
      </div>
    );

    const anyChildrenSelected = _.some(item.Items, si => si.isSelected);
    return (
      <div className="filter-lir">
        <div
          className={`filter-button-listitem-renderers ${item.isSelected ? '' : 'filter-button-listitem-renderers-disabled'}`}
          onClick={e => Misc.ignore(e, () => props.click(item.Value, 'groupHeader', item.Items))}>
          <div
            className={`filter-button-radio-arrow-toggle ${item.isExpanded ? '' : 'filter-button-radio-arrow-toggle-closed'}`}/>
          <span>{text}</span>
        </div>
        {item.isExpanded ? subItemsElementRoot : null}
      </div>
    );
  }
  return (
    <div className={`filter-button-listitem-renderers  ${disabledClass}`}
         onClick={e => Misc.ignore(e, () => props.click(props.item.Value))}>
      <div className={`filter-button-radio${disabledRadioClassPostfix}`}/>
      <span>{text}</span>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/stones/filterMaterialItem.js